// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Ufa3","footer":"ReportModalFilter_footer__2FSUe"};